/**
 * Composant d'accordéon personnalisé
 * Gère l'expansion et la réduction d'une section de contenu
 * @extends HTMLElement
 */
class TAccordeon extends HTMLElement {
  /**
   * @constructor
   * Initialise les éléments de l'accordéon
   */
  constructor() {
    super()
    this.initializeElements()
  }

  /**
   * Initialise les éléments DOM et les propriétés
   * @private
   */
  initializeElements() {
    /** @type {HTMLElement} L'en-tête de l'accordéon */
    this.head = this.querySelector('[data-accordeon-head]')

    /** @type {HTMLElement} Le corps de l'accordéon */
    this.body = this.querySelector('[data-accordeon-body]')

    /** @type {number} Padding bottom du corps en pixels */
    this.bodyPb = parseInt(this.body?.dataset?.accordeonBodyPb, 10) || 0
  }

  /**
   * Configure les écouteurs d'événements lorsque l'élément est connecté au DOM
   */
  connectedCallback() {
    this.head.addEventListener('click', this.handleToggle.bind(this))
  }

  /**
   * Gère le basculement de l'état de l'accordéon
   * @private
   */
  handleToggle() {
    const isOpen = this.body.getAttribute('data-accordeon-open') === 'true'
    this.toggleAccordeon(!isOpen)
  }

  /**
   * Bascule l'état de l'accordéon
   * @param {boolean} open - Si true, ouvre l'accordéon; si false, le ferme
   * @private
   */
  toggleAccordeon(open) {
    if (open) {
      this.openAccordeon()
    } else {
      this.closeAccordeon()
    }
  }

  /**
   * Ouvre l'accordéon
   * @private
   */
  openAccordeon() {
    this.classList.remove('is-close')
    this.body.style.maxHeight = `${this.body.scrollHeight + this.bodyPb}px`
    this.body.setAttribute('data-accordeon-open', 'true')
    this.head.setAttribute('aria-expanded', 'true')
  }

  /**
   * Ferme l'accordéon
   * @private
   */
  closeAccordeon() {
    this.classList.add('is-close')
    this.body.style.maxHeight = '0px'
    this.body.setAttribute('data-accordeon-open', 'false')
    this.head.setAttribute('aria-expanded', 'false')
  }

  /**
   * Nettoie les écouteurs d'événements lors de la déconnexion
   */
  disconnectedCallback() {
    this.head.removeEventListener('click', this.handleToggle.bind(this))
  }
}

customElements.define('t-accordeon', TAccordeon)
